import React from 'react'
import { string, array } from 'prop-types'

class seoSearchPageByPipe extends React.Component {
  makeItem (item, key) {
    return (
      <li key={key}>
        <a href={'/' + item.pageName + '.html'} title={item.pageTitle}>{ item.pageTitle.split('|')[0] }</a> <span dangerouslySetInnerHTML={{ __html: item.description }} />
      </li>
    )
  }

  render () {
    const { id, functionParams } = this.props
    let feeds = ''
    try {
      feeds = require('../../../../config/exports/buildTimeOnly/' + functionParams[0] + '.json')
    } catch (e) {
      // console.log( e );
    }

    if (!(feeds && feeds.length)) return null
    return (
      <ul id={id} className='pipesearch'>
        { feeds.map(this.makeItem) }
      </ul>
    )
  }
}

seoSearchPageByPipe.propTypes = {
  id: string,
  functionParams: array
}

export default seoSearchPageByPipe



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/seoSearchPageByPipe.jsx